import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import TopTableLoader from "../../../TopTablesComponents/TopTableLoader";
import {greyishBlue500} from "assets/jss/main";
import StockAlertMobileRow from "./components/StockAlertMobileRow";

StockAlertMobileList.propTypes = {
    data: PropTypes.object,
    loading: PropTypes.bool,
    currency: PropTypes.string,
    sortMode: PropTypes.oneOf([0, 1]),
};

function StockAlertMobileList({data, loading, currency, sortMode}) {
    if (loading) {
        return <TopTableLoader />
    }

    const rawProducts = data?.products ?? [];

    if (!rawProducts.length) {
        return (
            <div style={{color: greyishBlue500, fontSize: "14px", padding: "32px 0", textAlign: "center"}}>
                <FormattedMessage id="dashboard.productsRanking.table.no_result"/>
            </div>
        );
    }

    const products = [...rawProducts].sort((a, b) => {
        if (sortMode === 1) {
            return (b.alerts ?? 0) - (a.alerts ?? 0);
        }

        return (b.lostRevenue ?? 0) - (a.lostRevenue ?? 0);
    });

    return (
        <div style={{display: "flex", flexDirection: "column", background: 'unset'}}>
            {products.map((product, index) => (
                <StockAlertMobileRow
                    key={product.id ?? index}
                    rank={index + 1}
                    product={product}
                    currency={currency}
                />
            ))}
        </div>
    )
}

export default StockAlertMobileList;
